export default __webpack_public_path__ + "static/24_31-77eef328ea0599c4875fec8768dafc97.png";